// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import VueTouch from 'vue-touch'

import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import svgIcon from 'vue-svg-icon/Icon.vue'
import wx from 'weixin-js-sdk'

import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/js/filters'
import './components';
import './assets/css/main.scss';

import VueQriously from 'vue-qriously';

import dynamic from './common/dynamic'
import ajax from './common/ajax'
import helper from './common/helper'

import 'lib-flexible/flexible'

import LuckDraw from 'vue-luck-draw'
import { ImagePreview } from 'vant';


Vue.use(VueAxios, axios)
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(Vant)
Vue.use(VueQriously)
Vue.use(LuckDraw)
Vue.use(ImagePreview);

Vue.use(VueCookies)
Vue.component('icon', svgIcon)
global.wx = wx

Vue.use(ajax)
Vue.use(helper)
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: () => {
    return dynamic
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js